import React, { createContext, useContext, useState } from 'react';
import type { ReferralProgram } from '@/types/referral';

interface ReferralProgramEditContextType {
  isOpen: boolean;
  editingProgram: ReferralProgram | null;
  openEditProgram: (program: ReferralProgram) => void;
  closeEditProgram: () => void;
}

const ReferralProgramEditContext = createContext<ReferralProgramEditContextType | undefined>(undefined);

export const ReferralProgramEditProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [editingProgram, setEditingProgram] = useState<ReferralProgram | null>(null);

  const openEditProgram = (program: ReferralProgram) => {
    setEditingProgram(program);
    setIsOpen(true);
  };

  const closeEditProgram = () => {
    setIsOpen(false);
    setEditingProgram(null);
  };

  return (
    <ReferralProgramEditContext.Provider
      value={{
        isOpen,
        editingProgram,
        openEditProgram,
        closeEditProgram,
      }}
    >
      {children}
    </ReferralProgramEditContext.Provider>
  );
};

export const useReferralProgramEdit = () => {
  const context = useContext(ReferralProgramEditContext);
  if (context === undefined) {
    throw new Error('useReferralProgramEdit must be used within a ReferralProgramEditProvider');
  }
  return context;
};
